import React, { useState, useRef, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap still used for grid? Let's keep it for now but override styles
import Select from "react-select";
import avatar_en from "../data/en/Avatars.json";
// import { Button } from "react-bootstrap"; // Using standard button with Tailwind
import avatar_vi from "../data/vi/Avatars.json";
// import "./BaseHandle.css"; // Removed
import { useTranslation } from "react-i18next";
import pkg from "../../package.json";
import { customSelectStyles } from "../utils/styles";

const webCommandAPI = pkg["web-command-api"];

function HandleCharacter() {
  const [selectedOption, setSelectedOption] = useState(null);
  const [level, setLevel] = useState(1);
  const [rank, setRank] = useState(0);
  const [isExecuting, setIsExecuting] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [avatarData, setAvatarData] = useState([]);

  // Fetch data
  useEffect(() => {
    const fetchAvatarData = async () => {
      const url =
        currentLanguage === "vi"
          ? "https://raw.githubusercontent.com/arimetson/hotarusr-web-data/refs/heads/main/data/vi/Avatars.json"
          : "https://raw.githubusercontent.com/arimetson/hotarusr-web-data/refs/heads/main/data/en/Avatars.json";

      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error("Network response was not ok");
        const json = await res.json();
        setAvatarData(json);
      } catch (error) {
        // Fallback to local data
        setAvatarData(currentLanguage === "vi" ? avatar_vi : avatar_en);
      }
    };

    fetchAvatarData();
  }, [currentLanguage]);

  const handleSelectChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  const handleLevelChange = (value) => {
    let newValue = parseInt(value);
    if (isNaN(newValue) || newValue < 1) {
      newValue = 1;
    } else if (newValue > 80) {
      newValue = 80;
    }
    setLevel(newValue);
  };

  const handleRankChange = (value) => {
    let newValue = parseInt(value);
    if (isNaN(newValue) || newValue < 0) {
      newValue = 0;
    } else if (newValue > 6) {
      newValue = 6;
    }
    setRank(newValue);
  };

  // Hàm xử lý nút Execute
  const handleExecuteGive = () => {
    if (isExecuting) return;
    setIsExecuting(true);

    try {
      const savedKey = sessionStorage.getItem("playerKey");
      if (!savedKey) return;

      if (!selectedOption) return;

      let commandValue = `/give ${selectedOption.value} lv${level} r${rank} s10`;
      if (commandValue.startsWith("/")) {
        commandValue = commandValue.substring(1);
      }

      const encodedCommand = encodeURIComponent(commandValue);
      const url = `${webCommandAPI}/excute/${savedKey}/${encodedCommand}`;

      fetch(url, { mode: "no-cors" })
        .then((res) => res.text())
        .catch(() => { });
    } catch (_) { }

    setTimeout(() => {
      setIsExecuting(false);
    }, 5000);
  };

  const handleExecuteAvatar = () => {
    if (isExecuting) return;
    setIsExecuting(true);

    try {
      const savedKey = sessionStorage.getItem("playerKey");
      if (!savedKey) return;

      if (!selectedOption) return;

      let commandValue = `/avatar ${selectedOption.value} lv${level} r${rank} s10`;
      if (commandValue.startsWith("/")) {
        commandValue = commandValue.substring(1);
      }

      const encodedCommand = encodeURIComponent(commandValue);
      const url = `${webCommandAPI}/excute/${savedKey}/${encodedCommand}`;

      fetch(url, { mode: "no-cors" })
        .then((res) => res.text())
        .catch(() => { });
    } catch (_) { }

    setTimeout(() => {
      setIsExecuting(false);
    }, 5000);
  };

  const inputRef3 = useRef(null);
  const handleInputClick3 = () => {
    if (inputRef3.current) {
      inputRef3.current.select();
      document.execCommand("copy");
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 2000); // Hide notification after 2 seconds
    }
  };

  const inputRef4 = useRef(null);
  const handleInputClick4 = () => {
    if (inputRef4.current) {
      inputRef4.current.select();
      document.execCommand("copy");
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 2000); // Hide notification after 2 seconds
    }
  };

  const handleFocusAndClick = (e) => {
    e.target.select();
  };

  return (
    <div className="max-w-4xl mx-auto space-y-8 p-4">
      {/* Header Section */}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
        <div className="md:col-span-3">
          <h2 className="text-xl font-bold text-astral-purple">{t("avatars")}</h2>
        </div>
      </div>

      {/* Warning Message */}
      {/* Warning Message Removed */}

      {/* Inputs Section */}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-x-6 gap-y-4 items-center">
        {/* Character Name */}
        <div className="md:col-span-2">
          <h5 className="font-medium text-gray-300">{t("character-name")}</h5>
        </div>
        <div className="md:col-span-10">
          <Select
            styles={customSelectStyles}
            value={selectedOption}
            onChange={handleSelectChange}
            options={avatarData.map((avatar) => ({
              value: avatar.id,
              label: avatar.name,
            }))}
            placeholder={t("select_character")}
          />
        </div>

        {/* Level */}
        <div className="md:col-span-2">
          <h5 className="font-medium text-gray-300">{t("level")}</h5>
        </div>
        <div className="md:col-span-10">
          <input
            type="number"
            value={level}
            onChange={(e) => handleLevelChange(e.target.value)}
            min={1}
            max={80}
            className="glass-input"
            onClick={handleFocusAndClick}
            onFocus={handleFocusAndClick}
          />
        </div>

        {/* Eidolon */}
        <div className="md:col-span-2">
          <h5 className="font-medium text-gray-300">{t("eidolon")}</h5>
        </div>
        <div className="md:col-span-10">
          <input
            type="number"
            value={rank}
            onChange={(e) => handleRankChange(e.target.value)}
            min={0}
            max={6}
            className="glass-input"
            onClick={handleFocusAndClick}
            onFocus={handleFocusAndClick}
          />
        </div>
      </div>

      <hr className="border-white/10" />

      {/* Commands Section */}
      <div className="space-y-6">
        <h2 className="text-xl font-bold text-astral-purple">{t("command")}</h2>

        {/* Case 1: Don't have avatar */}
        <div className="glass-panel p-6 border border-white/5 rounded-xl space-y-4">
          <div className="text-sm text-stardust-gold-light italic flex items-center gap-2">
            <span className="text-astral-purple font-bold text-lg">•</span>
            <span dangerouslySetInnerHTML={{ __html: t("case_player_dont_have_avatar") }} />
          </div>
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1">
              {selectedOption && (
                <div className="relative group">
                  <input
                    type="text"
                    value={`/give ${selectedOption.value} lv${level} r${rank} s10`}
                    readOnly
                    ref={inputRef3}
                    className="glass-input font-mono text-sm w-full pl-4 pr-10 py-3 group-hover:bg-white/5 transition-colors"
                    onClick={handleInputClick3}
                  />
                  <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path></svg>
                  </div>
                </div>
              )}
            </div>
            <div>
              {selectedOption && (
                <button
                  className="glass-button-primary w-full md:w-auto px-8 whitespace-nowrap"
                  onClick={handleExecuteGive}
                  disabled={isExecuting}
                >
                  {isExecuting ? "Wait..." : "Execute"}
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Case 2: Have avatar */}
        <div className="glass-panel p-6 border border-white/5 rounded-xl space-y-4">
          <div className="text-sm text-stardust-gold-light italic flex items-center gap-2">
            <span className="text-astral-purple font-bold text-lg">•</span>
            <span dangerouslySetInnerHTML={{ __html: t("case_player_have_avatar") }} />
          </div>
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1">
              {selectedOption && (
                <div className="relative group">
                  <input
                    type="text"
                    value={`/avatar ${selectedOption.value} lv${level} r${rank} s10`}
                    readOnly
                    ref={inputRef4}
                    className="glass-input font-mono text-sm w-full pl-4 pr-10 py-3 group-hover:bg-white/5 transition-colors"
                    onClick={handleInputClick4}
                  />
                  <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path></svg>
                  </div>
                </div>
              )}
            </div>
            <div>
              {selectedOption && (
                <button
                  className="glass-button-primary w-full md:w-auto px-8 whitespace-nowrap"
                  onClick={handleExecuteAvatar}
                  disabled={isExecuting}
                >
                  {isExecuting ? "Wait..." : "Execute"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {showNotification && (
        <div className="fixed top-5 left-1/2 transform -translate-x-1/2 bg-green-500/90 text-white px-6 py-2 rounded-full shadow-xl z-50 animate-in fade-in slide-in-from-top-4">
          {t("copySuccess")}
        </div>
      )}
      <div className="h-24"></div>
    </div>
  );
}

export default HandleCharacter;
